import { useState } from 'react';
import { Popover } from '@base-ui-components/react/popover';
import StatBlock from "./StatBlock";
import { getImageUrl } from '../../constants';

export const CreaturePopup = ({ creature, handleSearchSelectCreature }) => {
    const [groupCount, setGroupCount] = useState(1)

    let currentEncounter = {encounterName: "DmBuddyCreaturePopup", creatures: [creature]}
    
    const setCurrentEncounter = () => {}
    const closeStatBlock = () => {}
    const handleUploadMonsterImage = () => {}

    const popAdd = (action) => {
        if (creature.avatarUrl === null) {
            getImageUrl(creature.name, creature.creature_type).then((url) => {
                creature.avatarUrl = url;
                // creature, action, event=undefined, count=1, fromBookGuid=undefined
                handleSearchSelectCreature(creature, action, undefined, groupCount)
            })
        } else {
            handleSearchSelectCreature(creature, action, undefined, groupCount)
        }
    } 

    return <Popover.Root openOnHover={true} delay={500}>
                <Popover.Trigger className='triggerButton'><b>{creature.name.split('|')[0]}</b></Popover.Trigger> 
                <div className='bookGroupButtonContainer'>
                    <div className='bookGroupButton' title={"Group -1 " + creature.name} onClick={() => setGroupCount(c => Math.max(1, c-1))}><b> - </b></div>
                    <div className='bookGroupCount' onClick={(e) => e.stopPropagation()}><b>{groupCount}</b></div>
                    <div className='bookGroupButton' title={"Group +1 " + creature.name} onClick={() => setGroupCount(c => c+1)}><b> + </b></div>
                </div>
                <button title={`Add '${creature.name}' to Encounter`} className='monsterPopUpAdd' onClick={() => popAdd("add")}>
                    ➕
                </button>
                <button title={`Pin '${creature.name}' Statblock`} className='monsterPopUpAdd' onClick={() => popAdd("select")}>
                    📝
                </button>
                <Popover.Portal>
                    <Popover.Positioner align={'end'} sticky={true}>
                        <Popover.Popup className='hoverPopup'>
                            <Popover.Description key={creature.name} style={{all: 'unset'}} render={<div />}>
                                <div className='statContainers' style={{flex: "1 1 0%", padding: "2px"}}>
                                    <div className='column' style={{width: "100%", height: "unset"}}>
                                        <StatBlock selectedIndex={0} 
                                            currentEncounter={currentEncounter}
                                            setCurrentEncounter={setCurrentEncounter}
                                            closeStatBlock={closeStatBlock}
                                            handleUploadMonsterImage={handleUploadMonsterImage}
                                        />
                                    </div>
                                </div>
                            </Popover.Description>
                        </Popover.Popup>
                    </Popover.Positioner>
                </Popover.Portal>
            </Popover.Root>;
}
